<div class="row bg-blue mx-0 mb-5">
	<div class="col-md px-0 d-flex align-items-center">
		<div
			class="w-100"
			[ngClass]="{
				'ps-md-5': locale.lang === 'en',
				'pe-md-5': locale.lang !== 'en'
			}"
		>
			<div class="d-flex align-items-center px-3 justify-content-center justify-content-md-start mb-3">
				<span
					class="cursor-pointer purple-background mb-40px fs-24px mx-2"
					dir="ltr"
					[ngClass]="{ 'text-start': locale.lang !== 'en', 'text-end': locale.lang === 'en' }"
				>
					{{ locale.translations['n729'] }}
				</span>
				<span
					class="mb-5 mt-2 fw-500 fg-purple d-flex align-items-center"
					[ngClass]="{
						'me-2': locale.lang === 'en',
						'ms-2': locale.lang !== 'en',
						'fs-20px': viewport.type === 'mobile',
						'fs-24px': viewport.type !== 'mobile'
					}"
				>
					{{ locale.translations['n724'] }}
				</span>
			</div>

			<span class="fg-purple fs-16px fw-500 text-center ms-3" [ngClass]="{ 'd-block': viewport.type === 'mobile' }">
				{{ locale.translations['n727'] }}
			</span>
			<span class="fg-purple fs-16px fw-500 text-center" [ngClass]="{ 'd-block': viewport.type === 'mobile' }">{{ locale.translations['n728'] }}</span>

			<div class="d-flex flex-column mt-3 flex-md-row justify-content-center text-center px-3">
				<button
					mat-flat-button
					class="fw-400 w-100 mt-auto mb-2 mb-md-0"
					[ngClass]="{ 'me-4': locale.lang === 'en', 'ms-4': locale.lang !== 'en' }"
					color="primary"
					(click)="onOpenWhatsapp()"
				>
					<img
						[src]="'/assets/images/social/whatsapp.svg' | s3Image"
						class="img-responsive wh-18px mb-1"
						[ngClass]="{ 'me-1': locale.lang === 'en', 'ms-1': locale.lang !== 'en' }"
					/>

					{{ locale.translations['n711'] }}
				</button>
				<button mat-stroked-button class="fw-400 w-100 btn-border" color="primary" (click)="onCallCustomerCare()">
					<mat-icon class="fs-18px mt-1 mat-icon-rtl-mirror">phone</mat-icon>
					{{ locale.translations['n712'] }}
				</button>
			</div>
		</div>
	</div>

	<div class="col-md px-0">
		<div class="pt-4 rounded" [ngClass]="{ 'ms-5': locale.lang === 'en', 'me-5': locale.lang !== 'en' }">
			<img
            [src]="(viewport.type !== 'mobile' ? 'assets/images/vip-plus/vip-plus-desktop.svg' : 'assets/images/vip-plus/vip-plus-mobile.svg') | s3Image"
            alt="vip plus" class="img-fluid"
			/>
		</div>
	</div>
</div>

<div class="row mb-5">
	<div class="col-12 mb-32px text-center fg-accent fs-24px fw-500">{{ locale.translations['n716'] }}</div>

	<div class="col-md-4 col-6" *ngFor="let features of vipPlusFeatures; let i = index">
		<div class="image-container">
			<img [src]="features.image | s3Image" alt="Image 1" class="img-fluid" />
			<p class="text-center mt-2 fg-black">{{ features.description }}</p>
		</div>
	</div>
</div>

<div class="divider-container mb-5">
	<mat-divider class="custom-divider"></mat-divider>
</div>

<div class="col-12 mb-32px text-center fg-accent fs-24px fw-500">{{ locale.translations['n736'] }}</div>

<!-- customer feedback -->
<div class="custom-carousel-container mb-5">
	<ngb-carousel #carousel="ngbCarousel" [interval]="false" *ngIf="happyCustomerData" class="custom-carousel">
		<ng-template ngbSlide *ngFor="let data of happyCustomerData; let i = index" id="{{ i }}">
			<div class="row px-3 pb-5" [ngClass]="{ 'px-5 pt-3': viewport.type === 'desktop', 'pt-5': viewport.type !== 'desktop' }">
				<div class="col-md-5 col-sm-12 text-section" [ngClass]="{ 'order-2': viewport.type !== 'desktop' }">
					<span
						[dir]="'rtl'"
						class="fs-16px fw-500 d-flex text-justify lh-20px feedback"
						[ngClass]="{ 'fs-24px lh-24px': viewport.type === 'desktop' }"
					>
						{{ data.feedback }}
					</span>

					<div [ngClass]="{ 'divider-container': viewport.type !== 'desktop', 'small-divider-container': viewport.type === 'desktop' }" class="my-3">
						<mat-divider class="divider"></mat-divider>
					</div>

					<audio (play)="stopOtherAudios($event.target)" controls #audios class="audio-player" controlsList="nodownload noplaybackrate">
						<source [src]="data.audioSrc" type="audio/mpeg" />
						Your browser does not support the audio element.
					</audio>
				</div>
				<div class="col-md-7 col-sm-12 image-section" [ngClass]="{ 'mt-2 mb-4 order-1 text-center': viewport.type !== 'desktop' }">
                    <img
                    [src]="(viewport.type === 'desktop' ? data?.image : data?.mobileImage) | s3Image"
                    class="img-fluid w-100 small-image"
                  />
                </div>
			</div>
		</ng-template>
	</ngb-carousel>
</div>

<div class="divider-container mb-5">
	<mat-divider class="custom-divider"></mat-divider>
</div>

<div class="row mb-5">
	<div class="col-12 text-center mb-3">
		<span class="fg-purple fs-16px fw-500">{{ locale.translations['n727'] }} {{ locale.translations['n728'] }}</span>
	</div>
	<div class="col-md-6 col-12 mx-auto text-center">
		<div class="d-flex flex-column flex-md-row justify-content-center">
			<button mat-flat-button class="fw-400 w-100 mx-md-2 mb-2 mb-md-0" color="primary" (click)="onOpenWhatsapp()">
				<img
					[src]="'/assets/images/social/whatsapp.svg' | s3Image"
					class="img-responsive wh-18px mb-1"
					[ngClass]="{ 'me-1': locale.lang === 'en', 'ms-1': locale.lang !== 'en' }"
				/>
				{{ locale.translations['n711'] }}
			</button>
			<button mat-stroked-button class="fw-400 w-100 btn-border mx-md-2" color="primary" (click)="onCallCustomerCare()">
				<mat-icon class="fs-18px mt-1 mat-icon-rtl-mirror">phone</mat-icon>
				{{ locale.translations['n712'] }}
			</button>
		</div>
	</div>
</div>
